import React from "react";
import {Filter, TextInput} from "react-admin";

export default (props) => (
  <Filter {...props}>
    <TextInput label='ID' source='id' alwaysOn/>
    <TextInput label='Title' source='title' alwaysOn/>
    <TextInput label='Message' source='message' alwaysOn/>
  </Filter>
);